import store from "../../config/store";
import { SiafLiteApiStream } from "../../external";
import SiafLiteApiRepository from "../../external/siafLiteApi";

class PessoaService {
  constructor() {
    this.urlBase = "/integracao/pessoas";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getByCnpjCpf(cnpjCPf) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/pessoa/${cnpjCPf}`,
    ).get();
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getAllFiltroAvancadoSimplificada(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/simplificada`).patch(
      body,
    );
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  cadastrarLista(body) {
    return new SiafLiteApiRepository(`${this.urlBase}/lista`).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  cadastrarEndereco(idPessoa, endereco) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/enderecos`,
    ).post(endereco);
  }

  cadastrarCliente(idPessoa, cliente) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/clientes`,
    ).post(cliente);
  }

  cadastrarFornecedor(idPessoa, fornecedor) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/fornecedores`,
    ).post(fornecedor);
  }

  cadastrarPessoaConfirmacao(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/confirmacao`).post(
      body,
    );
  }

  cadastrarTransportadora(idPessoa, transportadora) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/transportadoras`,
    ).post(transportadora);
  }

  cadastrarColaborador(idPessoa, colaborador) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/colaboradores`,
    ).post(colaborador);
  }

  cadastrarPrestadorServico(idPessoa, prestadorServico) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/prestador-servico`,
    ).post(prestadorServico);
  }

  getEnderecos(idPessoa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/enderecos`,
    ).get();
  }

  addAnexo(idPessoa, anexos) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/anexos`,
    ).post(anexos);
  }

  getAnexos(idPessoa) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${idPessoa}/anexos`,
    ).get();
  }

  relatorioClientesCadastrados(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/clientes`,
    ).path(body);
  }

  relatorioAniversario(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/aniversario-pessoas/resumido`,
    ).path(body);
  }

  relatorioAnaliseAbcClientes(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/analise-abc-clientes`,
    ).path(body);
  }

  relatorioDadosPessoa(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/dados-pessoas`,
    ).patch(body);
  }

  importarPessoas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/importacao`).post(body);
  }
}

export default PessoaService;
